const KEY = 'dots-draw.v1';

export type Progress = { cleared: number[]; last: number };

export function loadProgress(storage: Pick<Storage, 'getItem'> | null = safeStorage()): Progress {
  const empty: Progress = { cleared: [], last: 1 };
  if (!storage) return empty;
  try {
    const raw = storage.getItem(KEY);
    if (!raw) return empty;
    const j = JSON.parse(raw) as Partial<Progress>;
    const cleared = Array.isArray(j.cleared) ? [...new Set(j.cleared.filter((n) => Number.isInteger(n) && n > 0))].sort((a, b) => a - b) : [];
    const last = Number.isInteger(j.last) && (j.last as number) > 0 ? (j.last as number) : 1;
    return { cleared, last };
  } catch {
    return empty;
  }
}

export function saveProgress(p: Progress, storage: Pick<Storage, 'setItem'> | null = safeStorage()): void {
  if (!storage) return;
  try { storage.setItem(KEY, JSON.stringify(p)); } catch { /* 저장 불가(사파리 비공개 등) — 무시 */ }
}

export function markCleared(p: Progress, id: number): Progress {
  const cleared = p.cleared.includes(id) ? p.cleared : [...p.cleared, id].sort((a, b) => a - b);
  return { cleared, last: id };
}

function safeStorage(): Storage | null {
  try { return typeof localStorage !== 'undefined' ? localStorage : null; } catch { return null; }
}

/** 기본 공개 범위. ?stage=all 이면 전체가 열린다(관리자). */
export const VISIBLE_MAX = 100;
export function isAdmin(): boolean {
  try { return new URLSearchParams(location.search).get('stage') === 'all'; } catch { return false; }
}
/** 이 판을 지금 할 수 있나 — 깬 판의 다음 판까지만. */
export function isUnlocked(p: Progress, id: number): boolean {
  if (isAdmin()) return true;
  if (id > VISIBLE_MAX) return false;
  const maxCleared = p.cleared.length ? p.cleared[p.cleared.length - 1]! : 0;
  return id <= maxCleared + 1;
}

/** ?answer=1: 플레이 화면에 해답 버튼. */
export function answersOn(): boolean {
  try { return new URLSearchParams(location.search).get('answer') === '1'; } catch { return false; }
}
